// extracted by mini-css-extract-plugin
module.exports = {"container":"ThreeDSecurePrompt_container__2y6eu","text":"ThreeDSecurePrompt_text__3erOG","btn":"ThreeDSecurePrompt_btn__29hHE"};